import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GeneralLayoutComponent } from './general-layout/general-layout.component';
import { GeneralModule } from '../general/general.module';
import { RouterModule } from '@angular/router';
import { BlogAnnouncementsModule } from '../blog-announcements/blog-announcements.module';
import { NavigationModule } from '../navigation/navigation.module';
import { MobileWebViewLayoutComponent } from './mobile-web-view-layout/mobile-web-view-layout.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    GeneralModule,
    BlogAnnouncementsModule,
    NavigationModule
  ],
  declarations: [
    GeneralLayoutComponent,
    MobileWebViewLayoutComponent,
  ],
  exports: [
    GeneralLayoutComponent,
  ]
})
export class LayoutModule { }
